import React, { useState } from "react";
import "./styles.css";
import FloatingContainer from "../FloatingContainer";
import copyIcon from "../../../assets/img/copy.png";

const infoModal = ({ onClose, roomId, attendeeId, ...props }) => {
  const [activeTooltip, setActiveTooltip] = useState(null);

  const handleCopy = (text, id) => {
    navigator.clipboard.writeText(text).then(() => {
      setActiveTooltip(id);
      setTimeout(() => setActiveTooltip(null), 4000); // Reset after 2 seconds
    });
  };

  const renderCopyIcon = (text, id) => (
    <div className="copy-icon-container" onClick={() => handleCopy(text, id)}>
      <img width={16} src={copyIcon} alt="Copy" />
      <div className={`tooltip-copy ${activeTooltip === id ? "active" : ""}`}>
        <p>{activeTooltip === id ? "Copied!" : "Copy"}</p>
        <div className="triangle-copy"></div>
      </div>
    </div>
  );

  return (
    <FloatingContainer className="invite-menu" offset="invite" onClose={onClose} instructions="" {...props}>
      <div id="invite-cont" className="column">
        <p className="menu-title">Invite users</p>
        <p className="info-modal-text">You are the Host of this session. Copy and share these codes to invite new participants:</p>

        <div className="menu-box-container margin-btm column">
          <p className="menu-box-title">Active users</p>
          <p className="menu-box-text margin-btm">They can talk, enter AR/VR, and grab atoms/objects.</p>
          <div className="code-container row">
            <p className="invite-code">{roomId}</p>
            {renderCopyIcon(roomId, "active-users")}
          </div>
        </div>

        <div className="menu-box-container column">
          <p className="menu-box-title">Others - Attendees - Listeners</p>
          <p className="menu-box-text margin-btm">
            They listen to the discussion or presentation but cannot actively participate in AR/VR.
          </p>
          <div className="code-container row">
            <p className="invite-code">{attendeeId}</p>
            {renderCopyIcon(attendeeId, "attendees")}
          </div>
        </div>
      </div>
    </FloatingContainer>
  );
};
export default infoModal;
